module.exports = {
    props: ['user'],
    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                show_only_assignments: '',
                timezone: '',
            }), Spark.forms.defaultPreferences)
        };
    },
    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.show_only_assignments = this.user.show_only_assignments;
        this.form.timezone = this.user.timezone;
    },
    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            console.log(this.form);
            Spark.put(`settings/preferences/default`, this.form)
                .then(() => {
                    Bus.$emit('updateUserData');
                });
        }
    }
};
